import { useEffect, useState } from "react";
import { Receipt, ExternalLink, Download, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const STATUS = {
  paid: ["Paid", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  open: ["Unpaid", "bg-red-50 text-red-700 border-red-200"],
  uncollectible: ["Failed", "bg-red-50 text-red-700 border-red-200"],
};

function Row({ r }) {
  const [label, cls] = STATUS[r.status] || [r.status, "bg-slate-50 text-slate-600 border-slate-200"];
  return (
    <div className="grid grid-cols-2 sm:grid-cols-[1fr_1.6fr_auto_auto_auto] items-center gap-x-4 gap-y-1 py-3.5 border-b last:border-0" data-testid={`receipt-row-${r.id}`}>
      <div className="text-sm font-medium">{r.date}</div>
      <div className="text-sm text-slate-600 truncate">
        {r.description}
        {r.period && <span className="block text-xs text-slate-400">{r.period}</span>}
      </div>
      <div className="text-sm font-semibold tabular-nums" data-testid={`receipt-amount-${r.id}`}>{r.amount_label}</div>
      <span className={`justify-self-start text-xs font-medium px-2 py-0.5 rounded-full border ${cls}`} data-testid={`receipt-status-${r.id}`}>{label}</span>
      <div className="flex gap-3 col-span-2 sm:col-span-1 sm:justify-end">
        {r.invoice_url && (
          <a href={r.invoice_url} target="_blank" rel="noopener noreferrer" className="text-sm text-primary hover:underline inline-flex items-center gap-1" data-testid={`receipt-view-${r.id}`}>
            <ExternalLink className="h-3.5 w-3.5" />{r.status === "open" ? "Pay" : "View"}
          </a>
        )}
        {r.pdf_url && (
          <a href={r.pdf_url} target="_blank" rel="noopener noreferrer" className="text-sm text-primary hover:underline inline-flex items-center gap-1" data-testid={`receipt-pdf-${r.id}`}>
            <Download className="h-3.5 w-3.5" />PDF
          </a>
        )}
      </div>
    </div>
  );
}

export function BillingHistoryCard() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/payments/receipts").then((r) => setList(r.data)).catch(() => setList([])); }, []);
  return (
    <section className="rounded-2xl border bg-white p-6 sm:p-7" data-testid="billing-history-card">
      <div className="flex items-center gap-2 mb-1">
        <Receipt className="h-4 w-4 text-primary" />
        <h2 className="text-lg font-semibold">Billing history</h2>
      </div>
      <p className="text-sm text-slate-500 mb-4">Every invoice for your plan. Open or download any receipt for your records.</p>
      {list === null ? (
        <div className="py-6 flex justify-center"><Loader2 className="h-5 w-5 animate-spin text-primary" /></div>
      ) : list.length === 0 ? (
        <p className="text-sm text-slate-500 py-4" data-testid="billing-history-empty">No invoices yet. They'll appear here after your first payment.</p>
      ) : (
        <div data-testid="billing-history-list">{list.map((r) => <Row key={r.id} r={r} />)}</div>
      )}
    </section>
  );
}
